import React from 'react';
import { Typography, styled, Box, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { RoundButton } from '../round-button';

export const CallBox = styled(Box)(style => ({
    width: '400px',
    marginBottom: '12px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    borderRadius: '16px',
    overflow: 'hidden',
    backgroundColor: style.theme.palette.background.paper,
    color: style.theme.palette.text.primary
}));

export const CallHeader = styled(Box)({
    padding: '16px 24px',
    minHeight: '100px',
    WebkitAppRegion: 'drag',
    WebkitUserSelect: 'none'
});

export const CallDetails = styled(Box)(style => ({
    backgroundColor: style.theme.palette.background.default
}));

export const CallActionBox = styled(Box)({
    padding: '4px 8px 0'
});

export const CallStateActive = styled((props: any) => <Typography variant='subtitle2' {...props} />)(style => ({
    color: style.theme.palette.success.main
}));

export const CallStateError = styled((props: any) => <Typography variant='subtitle2' {...props} />)(style => ({
    color: '#FF3D32'
}));

export const CallStateOnhold = styled(CallStateActive)(style => ({
    color: style.theme.palette.info.main
}));

export const CallButton = styled(RoundButton)({
    color: 'white',
    marginLeft: '8px',
    marginTop: '18px',
    WebkitAppRegion: 'no-drag',
    backgroundColor: 'rgb(6, 69, 95)',
    transition: '0.2s',
    width: '48px',
    height: '48px',
    '&:hover': {
        opacity: '0.8',
        transform: 'scale(1.1)',
        transition: '0.2s',
        backgroundColor: 'rgb(6, 69, 95)',
    }
});

export const CloseButton = styled(RoundButton)({
    position: 'absolute',
    top: '-12px',
    right: '-2px',
    zIndex: 100
});

export const ButtonWarning = styled(LoadingButton)(() => ({
    marginTop: '8px',
    display: 'block',
    background: '#E31B0C',
    color: '#FFF',
    marginLeft: 'auto',
    textTransform: 'initial',
    fontSize: 14,
    WebkitAppRegion: 'no-drag',
    '&:hover': {
        background: '#621B16'
    },
    '&.MuiLoadingButton-loading': {
        background: '#E31B0C',
        color: '#FFF',
        display: 'flex',
    },
    '&.MuiLoadingButton-loading:after': {
        content: '""',
        width: '24px'
    }
}));

export const AlertError = styled(Alert)(() => ({
    color: '#621B16',
    backgroundColor: '#F7CECD',
    borderRadius: '16px',
    marginTop: '16px',
    '& a': {
        color: '#621B16',
        textDecoration: 'underline'
    }
}));

export const InfoBanner = styled(Alert)(() => ({
  color: '#0675DD',
  backgroundColor: '#CEE8FF',
  borderRadius: 0,
  marginTop: 0,
  '& a': {
      color: '#0675DD',
      textDecoration: 'underline'
  },
  '> .MuiAlert-message': {
    width: '100% !important'
  }
}));

export const SuccessBanner = styled(Alert)(() => ({
  color: '#005E05',
  backgroundColor: '#D8F8D9',
  borderRadius: 0,
  marginTop: 0,
  '& a': {
      color: '#005E05',
      textDecoration: 'underline'
  },
  '> .MuiAlert-message': {
    width: '100% !important'
  }
}));

